module.exports = __webpack_public_path__ + "img/settings.6a67e82f.svg";